module.exports = __webpack_public_path__ + "static/coliving-kitchen-2-3447e608e4d2757be936bd1af76ee1c5.jpg";